import {NgModule} from '@angular/core'
import {RouterModule, Routes} from '@angular/router'
import { AdminAuthorized } from './core/guards/admin-authorized.guard'

import {UserAlreadyLogged} from './core/guards/user-already-logged.guard'
import {UserAuthorized} from './core/guards/user-authorized.guard'
import {MgaBlocked} from './core/guards/mga-blocked.guard'
import { MirrorPoliciesGuard } from './core/guards/mirror-policies.guard'
import { OonEnabledGuard } from './core/guards/oon-enabled.guard'
import { SimplifiedBlocked } from './core/guards/simplified-blocked.guard'


const routes: Routes = [
    {
        path: 'auth',
        loadChildren: async () =>
            await import('./features/auth/auth.module').then((m) => m.AuthModule),
        canActivate: [UserAlreadyLogged],
        data: {
            headerConfig :  {
                headerTitle: 'Dashboard',
                ctaHeaderLabel: 'Relatórios'
            }
        }

    },
    {
        path: 'dashboard',

        loadChildren: async () =>
            await import('./features/dashboard/dashboard.module').then(
                (m) => m.DashboardModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked],
        data: {
            pageTitle: 'DashBoard'
        }

    },
    {
        path: 'dashboard-inicial',
        loadChildren: async () =>
            await import('./features/dashboard-inicial/dashboard-inicial.module').then(
                (m) => m.DashboardInicialModule
            ),
        canActivate: [UserAuthorized, MgaBlocked],
        data: {
            pageTitle: 'Dashboard Inicial'
        }
    },
    {
        path: 'customers',
        loadChildren: async () =>
            await import('./features/customer/customer.module').then(
                (m) => m.CustomerModule
            ),
        canActivate: [UserAuthorized]
    },

    { path: 'work-panel', loadChildren:
            () => import('./features/work-panel/work-panel.module').then(m => m.WorkPanelModule),
        canActivate: [UserAuthorized, MgaBlocked]
    },

    {
        path: 'devices',
        loadChildren: async () =>
            await import('./features/equipment/devices.module').then(
                (m) => m.DevicesModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked]
    },

    {
        path: 'vehicles',
        loadChildren: async () =>
            await import('./features/vehicle/vehicle.module').then((m) => m.VehicleModule),
        canActivate: [UserAuthorized]
    },
    {
        path: 'statement',
        loadChildren: async () =>
            await import('./features/statement/statement.module').then(
                (m) => m.StatementModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked]
    },

    {
        path: 'dunnings',
        loadChildren: async () =>
            await import('./features/dunnings/list-dunning.module').then(
                (m) => m.ListDunningModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked]
    },
    {
        path: 'invoice',
        loadChildren: async () =>
            await import('./features/invoice/invoice.module').then(
                (m) => m.InvoiceModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked]
    },
    {
        path: 'profile',
        loadChildren: async () =>
            await import('./features/user/user.module').then(
                (m) => m.UserModule
            ),
        canActivate: [UserAuthorized]
    },
    {
        path: 'users-management',
        loadChildren: async () =>
            await import('./features/users-management/users-management.module').then(
                (m) => m.UsersManagementModule
            ),
        canActivate: [UserAuthorized]
    },
    {
        path: 'admin',
        loadChildren: async () =>
            await import('./features/admin/admin.module').then(
                (m) => m.AdminModule
            ),
        canActivate: [AdminAuthorized]
    },
    {
        path: 'documentos',
        loadChildren: async () =>
            await import('./features/admin/system-documents-list/system-documents-list.module').then(
                (m) => m.SystemDocumentsListModule
            ),
        canActivate: [UserAuthorized]
    },
    {
        path: 'apolices',
        loadChildren: async () =>
            await import('./features/policies/policies.module').then(
                (m) => m.PoliciesModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked]
    },
    {
        path: 'oon-policies',
        loadChildren: async () =>
            await import('./features/oon-policies/oon-policies.module').then(
                (m) => m.OonPoliciesModule
            ),
        canActivate: [UserAuthorized, OonEnabledGuard]
    },
    {
        path: 'oon-sinisters',
        loadChildren: async () =>
            await import('./features/oon-sinisters/oon-sinisters.module').then(
                (m) => m.OonSinistersModule
            ),
        canActivate: [UserAuthorized, OonEnabledGuard]
    },
    {
        path: 'mirror-policies',
        loadChildren: async () =>
            await import('./features/mirror-policies/mirror-policies.module').then(
                (m) => m.MirrorPoliciesModule
            ),
        canActivate: [UserAuthorized, MirrorPoliciesGuard]
    },
    {
        path: 'contracts',
        loadChildren: async () =>
            await import('./features/contracts/contracts.module').then(
                (m) => m.ContractsModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked]
    },
    {
        path: 'charges',
        loadChildren: async () =>
            await import('./features/charges/charges.module').then(
                (m) => m.ChargesModule
            ),
        canActivate: [UserAuthorized, SimplifiedBlocked]
    },
    {
        path: 'area-cliente',
        loadChildren: async () =>
            await import('./features/client-area/client-area.module').then(
                (m) => m.ClientAreaModule
            ),
    },
    {
        path: 'ordem-servico',
        loadChildren: async () =>
            await import('./features/service-order/service-order.module').then(
                (m) => m.ServiceOrderModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked]
    },
    {
        path: 'tecnicos',
        loadChildren: async () =>
            await import('./features/technician/technician.module').then(
                (m) => m.TechnicianModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked]
    },

    {
        path: 'relatorios',
        loadChildren: async () =>
            await import('./features/reports/reports.module').then(
                (m) => m.ReportsModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked]
    },

    {
        path: 'monitoramento',
        loadChildren: async () =>
            await import('./features/monitoring/monitoring.module').then(
                (m) => m.MonitoringModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked]
    },
    {
        path: 'notificacoes',
        loadChildren: async () =>
            await import('./features/notifications/notifications.module').then(
                (m) => m.NotificationsModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked],
        data: { title: 'Notificações' }
    },
    {
        path: 'alertas',
        loadChildren: async () =>
            await import('./features/notifications/notifications.module').then(
                (m) => m.NotificationsModule
            ),
        canActivate: [UserAuthorized, MgaBlocked, SimplifiedBlocked],
        data: { title: 'Central de Alertas' }
    },
    {
        path: 'external',
        loadChildren: async () =>
            await import('./features/external-links/external-links.module').then(
                (m) => m.ExternalLinksModule
            )
    },
    {
        path: 'products',
        loadChildren: async () =>
            await import('./features/product/product.module').then(
                (m) => m.ProductModule
            )
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
    },

    {
        path: '**',
        redirectTo: ''
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
